import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export interface FlowIconProps extends SvgIconProps {
  /**
   * SVG of Flow icon in string, e.g. ActionsIcons.Heart.stroke
   */
  source?: string;
}

/**
 * Renders Flow svg icon in string as @mui SvgIcon
 */
export const FlowIcon: React.FC<FlowIconProps> = forwardRef(({ source, ...rest }, ref) => {
  return (
    <SvgIcon viewBox="0 0 80 80" ref={ref} {...rest}>
      {(source?.match(/<path[^>]+>/g) ?? []).map((tag, i) => {
        const d = tag.match(/d="([^"]+)"/)?.[1];
        const fill = tag.match(/fill="([^"]+)"/)?.[1];
        const opacity = tag.match(/opacity="([^"]+)"/)?.[1];

        return (
          <path
            key={i}
            fillRule="evenodd"
            clipRule="evenodd"
            opacity={opacity}
            {...(fill !== 'currentColor' && { fill: fill })}
            d={d}
          />
        );
      })}
      {(source?.match(/<circle[^>]+>/g) ?? []).map((tag, i) => {
        const fill = tag.match(/fill="([^"]+)"/)?.[1];
        const cx = tag.match(/cx="([^"]+)"/)?.[1];
        const cy = tag.match(/cy="([^"]+)"/)?.[1];
        const r = tag.match(/r="([^"]+)"/)?.[1];

        return <circle key={i} cx={cx} cy={cy} r={r} {...(fill !== 'currentColor' && { fill: fill })} />;
      })}
    </SvgIcon>
  );
});
